import { FetchableList } from "@/src/components/fetchableLists";
import apiFetch from "@/src/utils/apiFetch";
import DicomReceptionCard from "./dicomReceptionCard";
import { DicomReception, FolderItem, Patient } from "@/src/data/allTypes";
import { getItemId } from "@/src/utils/utils";
import { useState } from "react";

function DicomReceptionsList({
  patient,
  parent,
  onAssign,
}: {
  patient: Patient;
  parent: FolderItem | null | undefined;
  onAssign: (dicomReception: DicomReception) => void;
}) {
  const [reload, setReload] = useState(0);
  return (
    <FetchableList
      queryKey={["DicomReceptionsList", getItemId(patient), parent?.id]}
      queryFn={() =>
        apiFetch(
          "dicomReceptions",
          "loadMany",
          { patientId: getItemId(patient) },
          ""
        )
      }
      emptyChild={<div></div>}
    >
      {(data) => {
        return (
          <div className="c1 mc1 gap15">
            {data?.map((dicomReception) => {
              return (
                <DicomReceptionCard
                  key={dicomReception.id}
                  dicomReception={dicomReception}
                  parent={parent}
                  onAssign={(dicomReception) => {
                    onAssign(dicomReception);
                    setReload(reload + 1);
                  }}
                />
              );
            })}
          </div>
        );
      }}
    </FetchableList>
  );
}

export default DicomReceptionsList;
